import { render, staticRenderFns } from "./TruvitoLoginModal.vue?vue&type=template&id=445aedfa&scoped=true&"
import script from "./TruvitoLoginModal.vue?vue&type=script&lang=js&"
export * from "./TruvitoLoginModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445aedfa",
  null
  
)

export default component.exports